import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Lang } from '@app/i18n/lang.type';
import { ChangeLangValueDto, ChangePasswordValue, ChangePasswordValueDto, UserValue, UserValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    changePassword(value: ChangePasswordValue) {
        const params = new ChangePasswordValueDto(value);

        return this.httpClient.put('api/v1/users/password', params);
    }

    changeLanguage(value: Lang) {
        const params = new ChangeLangValueDto(value);

        return this.httpClient.post('api/v1/users/me/language', params);
    }

    editUser(value: UserValue) {
        const params = new UserValueDto(value);

        return this.httpClient.patch('api/v1/users/me', params);
    }
}
